import { IconCloseMS } from '@/constants/icons';
import { Box, Typography } from '@mui/material';

import { Button } from '../Button';
import { ButtonBox, StyledTab, StyledTabList, TabLabel } from './styles';
import { TabItem } from './types';

type TabsHeaderProps = {
  tabs: TabItem[];
  onChange: (value: string) => void;
  onClose: (value: string) => void;
  onCloseAll: () => void;
};

export function TabsHeader({
  tabs,
  onChange,
  onClose,
  onCloseAll,
}: TabsHeaderProps): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        minWidth: 0,
      }}
    >
      <StyledTabList
        variant="scrollable"
        scrollButtons={false}
        onChange={(_, value) => onChange(value)}
      >
        {tabs.map((tab) => (
          <StyledTab
            key={tab.value}
            value={tab.value}
            label={
              <TabLabel>
                <Box sx={{ minWidth: 0 }}>
                  <Typography className="title">{tab.title}</Typography>
                  <Typography className="subtitle">{tab.subtitle}</Typography>
                </Box>
                <Button
                  variant="text"
                  onClick={(e) => {
                    e.stopPropagation();
                    onClose(tab.value.toString());
                  }}
                >
                  {IconCloseMS}
                </Button>
              </TabLabel>
            }
          />
        ))}
      </StyledTabList>
      <ButtonBox>
        <Button variant="text" onClick={onCloseAll}>
          {IconCloseMS}
        </Button>
      </ButtonBox>
    </Box>
  );
}
